import { render, staticRenderFns } from "./roles.view.vue?vue&type=template&id=9c7c6cae"
import script from "./roles.view.vue?vue&type=script&lang=js"
export * from "./roles.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports